import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap'

const ConfirmationModal = ({
  show,                         // Controlled from parent
  onClose,                      // Function to close modal
  title = 'Confirmation',
  message = 'Are you sure?',
  onConfirm,
  confirmText = 'Confirm',
  cancelText = 'Cancel'
}) => {
  const handleConfirm = () => {
    if (onConfirm) onConfirm()
    onClose()
  }

  return (
    <Modal
      className='confirmation-modal'
      show={show}
      onHide={onClose}
      centered
    >
      <ModalHeader closeButton>
        <span className='fw-bold'>{title}</span>
      </ModalHeader>
      <ModalBody>
        <div>{message}</div>
      </ModalBody>
      <ModalFooter>
        <Button
          variant='secondary'
          onClick={onClose}
        >
          {cancelText}
        </Button>
        <Button
          variant='primary'
          onClick={handleConfirm}
        >
          {confirmText}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ConfirmationModal
